import { useState } from "react"
import ReelTokenPage from "@/pages/ReelTokenPage"
import SwapPage from "@/pages/SwapPage"

const TABS = [
  { id: "swap", label: "Swap" },
  { id: "token", label: "Token" },
] as const

type WalletTab = (typeof TABS)[number]["id"]

export default function WalletPage() {
  const [tab, setTab] = useState<WalletTab>("swap")

  return (
    <div>
      <div className="mx-auto max-w-4xl px-4 pt-5 lg:px-8">
        <p className="text-[11px] uppercase tracking-[0.22em] text-[#6E6E6E]">KLIPO Wallet</p>
        <h1 className="mt-1 font-[Syne] text-2xl font-bold">Wallet</h1>
        <div className="mt-4 grid grid-cols-2 gap-1 rounded-full bg-[#141414] p-1">
          {TABS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setTab(item.id)}
              className={`rounded-full py-2 text-sm font-semibold transition ${
                tab === item.id ? "bg-[#00FF66] text-black" : "text-[#A8A8A8]"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
      {tab === "swap" ? <SwapPage /> : <ReelTokenPage />}
    </div>
  )
}
